import { Modal, QuizResultStatus } from '..';
import { useLocalize, useModal } from '../../hooks';
import type { CompleteQuizResult, CourseType } from '../../api';

type SuccessProps = {
  result?: CompleteQuizResult;
  course?: CourseType;

  isOpened?: boolean;
  onClose?: () => void;
};

const icon = (
  <svg
    width="180"
    height="180"
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M180 90C180 139.706 139.706 180 90 180C40.2944 180 0 139.706 0 90C0 40.2944 40.2944 0 90 0C139.706 0 180 40.2944 180 90Z"
      fill="#F0FAEB"
    />
    <path
      d="M164 90C164 130.869 130.869 164 90 164C49.1309 164 16 130.869 16 90C16 49.1309 49.1309 16 90 16C130.869 16 164 49.1309 164 90Z"
      fill="#DBF4D3"
    />
    <path
      d="M152 90C152 124.242 124.242 152 90 152C55.7583 152 28 124.242 28 90C28 55.7583 55.7583 28 90 28C124.242 28 152 55.7583 152 90Z"
      fill="#5BBD42"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.998 71.0683L80.3496 97.9657L72.7475 90.0638C71.3471 88.7793 69.1465 88.7014 67.5461 89.7913C65.9856 90.9202 65.5455 92.9054 66.5058 94.5013L75.5083 108.748C76.3885 110.071 77.9089 110.889 79.6294 110.889C81.2699 110.889 82.8303 110.071 83.7106 108.748C85.151 106.918 112.639 75.0386 112.639 75.0386C116.24 71.4575 111.878 68.3046 108.998 71.0293V71.0683Z"
      fill="white"
    />
  </svg>
);

export const FinishedModal: React.FC<SuccessProps> = ({
  result,
  course,
  isOpened,

  onClose,
}) => {
  const { t } = useLocalize();
  const { isOpened: localOpen, onClose: localClose } = useModal(true);

  return (
    <Modal
      size="small"
      open={isOpened ?? localOpen}
      onClose={onClose ?? localClose}
      contentClassName="p-xl pb-2xl"
    >
      <div className="flex flex-col items-center justify-between gap-y-lg">
        <div className="font-bold text-big">
          {t('quiz.page.congratulations')} 🎉
        </div>
        {icon}
        <div className="font-medium text-small px-md">
          {result
            ? t('quiz.page.completeinfo')
            : t('course.page.completeinfo').replace(
                '{course title}',
                course?.title || ''
              )}
        </div>
        {!!result && <QuizResultStatus result={result} big />}
      </div>
    </Modal>
  );
};
